import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-password-validation-section",
  templateUrl: "./password-validation-section.component.html",
  styleUrls: ["./password-validation-section.component.scss"],
})
export class PasswordValidationSectionComponent implements OnInit {
  @Input() control;

  constructor() {}

  ngOnInit(): void {}
}
